export default "__VITE_ASSET__34951989__"